import moment from 'moment';

export function filterRetouchCalendar(groupedDays = {}, weekdays = [], artistSearch = '', today = moment()) {
  const result = {};
  Object.entries(groupedDays).forEach(([monthKey, month]) => {
    const artists = {};
    Object.entries(month.artists || {}).forEach(([name, artist]) => {
      if (artistSearch && !name.toLowerCase().includes(artistSearch.toLowerCase())) return;
      const dates = (artist.dates || []).filter(day => {
        const date = moment(day.day);
        return date.isValid() && date.isSameOrAfter(today, 'day') &&
          (weekdays.length === 0 || weekdays.includes(date.isoWeekday()));
      });
      if (dates.length) artists[name] = { ...artist, dates };
    });
    if (Object.keys(artists).length) result[monthKey] = { ...month, artists };
  });
  return result;
}
